export const isFieldSupportedForBucketing = (field: FieldDto) =>
    ['date', 'datetime'].indexOf(field.type) >= 0
